import { toast } from 'sonner';
import api from '../../../lib/api';

export function fmtCLP(n) {
  if (n === null || n === undefined) return '$ 0';
  return Number(n).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });
}

// Iter 378 — relee un egreso/ingreso desde Alegra y muestra qué cambió. `col`: 'egresos' | 'ingresos'.
export async function refrescarDesdeAlegra(col, doc) {
  const label = col === 'egresos' ? 'Comprobante de Egreso' : 'Recibo de Caja';
  try {
    const r = await api.post(`/contabilidad/${col}/${doc.id}/refrescar-alegra`);
    const d = r.data.egreso || r.data.ingreso || {};
    const cambios = Object.entries(r.data.cambios || {}).filter(([k]) => !k.startsWith('facturas_'))
      .map(([k, v]) => (k === 'monto' ? `monto ${fmtCLP(v.antes)} → ${fmtCLP(v.ahora)}` : `${k} ${v.antes ?? '—'} → ${v.ahora ?? '—'}`)).join(', ');
    if (r.data.eliminado_en_alegra) toast.warning(`${label} N°${doc.alegra_number || '—'} ya no existe en Alegra: quedó anulado en el ERP`);
    else if (cambios) toast.success(`${label} N°${d.alegra_number || doc.alegra_number} actualizado desde Alegra: ${cambios}`, { duration: 7000 });
    else toast.info(`${label} N°${doc.alegra_number || '—'}: sin cambios en Alegra`);
    if (r.data.aviso_conciliacion) toast.warning(r.data.aviso_conciliacion, { duration: 8000 });
    return r.data;
  } catch (err) {
    toast.error(err?.response?.data?.detail || 'No se pudo actualizar desde Alegra');
    return null;
  }
}

export const APLICACION_BADGE = {
  pendiente: { cls: 'bg-amber-100 text-amber-800 border-amber-300', label: 'Pendiente' },
  parcial: { cls: 'bg-blue-100 text-blue-800 border-blue-300', label: 'Parcial' },
  aplicado: { cls: 'bg-emerald-100 text-emerald-800 border-emerald-300', label: 'Aplicado' },
  cancelado: { cls: 'bg-gray-100 text-gray-600 border-gray-300', label: 'Cancelado' },
  no_aplica: { cls: 'bg-slate-50 text-slate-500 border-slate-200', label: 'Gasto directo' },
};

export const APLICACION_BADGE_INGRESO = {
  ...APLICACION_BADGE,
  aplicado: { cls: 'bg-emerald-100 text-emerald-800 border-emerald-300', label: 'Facturas cobradas' },
  pendiente: { cls: 'bg-amber-100 text-amber-800 border-amber-300', label: 'Anticipo cliente' },
  no_aplica: { cls: 'bg-slate-50 text-slate-500 border-slate-200', label: 'Otro ingreso' },
};

export const CONCILIACION_BADGE = {
  pendiente: { cls: 'bg-amber-100 text-amber-800 border-amber-300', label: 'Pendiente' },
  conciliado: { cls: 'bg-emerald-100 text-emerald-800 border-emerald-300', label: 'Conciliado' },
  observado: { cls: 'bg-orange-100 text-orange-800 border-orange-300', label: 'Observado' },
  no_aplica: { cls: 'bg-slate-50 text-slate-500 border-slate-200', label: 'Sin cartola' },
};

export const TIPO_LABEL = {
  anticipo: 'Anticipo', pago_factura: 'Pago factura', gasto: 'Gasto',
  cobro_factura: 'Cobro factura', anticipo_cliente: 'Anticipo cliente', otro_ingreso: 'Otro ingreso',
};

export const PRIORIDAD_LABEL = {
  1: 'P1 · exacto (monto + nombre/RUT + fecha)',
  2: 'P2 · monto + nombre similar / RUT',
  3: 'P3 · solo monto (revisión manual)',
  manual: 'Manual',
  auto_tef: 'Auto · nómina TEF (grupo)',
  auto_beneficiario: 'Auto · beneficiario + código (grupo)',
  auto_codigo_detalle: 'Auto · código + detalle (grupo)',
  legado: 'Legado',
  vb: 'VB pago cliente',
};

// Configuración por sentido: Egresos (cargos) / Ingresos (abonos). Mismos componentes, distinta API y textos.
export const MODOS = {
  egreso: {
    key: 'egreso', base: '/contabilidad/egresos', label: 'Egreso', plural: 'Egresos', contraparte: 'Proveedor', docLabel: 'Comprobante',
    montoMov: 'cargo', aplicacionBadge: APLICACION_BADGE, colorMonto: 'text-red-600', rutCampo: 'rut_proveedor',
    conOC: true, conFacturasAplicadas: 'facturas_aplicadas',
  },
  ingreso: {
    key: 'ingreso', base: '/contabilidad/ingresos', label: 'Ingreso', plural: 'Ingresos', contraparte: 'Cliente', docLabel: 'Recibo de Caja',
    montoMov: 'abono', aplicacionBadge: APLICACION_BADGE_INGRESO, colorMonto: 'text-emerald-700', rutCampo: 'rut_cliente',
    conOC: false, conFacturasAplicadas: 'facturas_cobradas',
  },
};

export function EstadoBadge({ map, estado, testId }) {
  const b = map[estado] || { cls: 'bg-gray-100 text-gray-600 border-gray-300', label: estado || '—' };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium border whitespace-nowrap ${b.cls}`} data-testid={testId}>
      {b.label}
    </span>
  );
}
